import * as React from 'react';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Alert, Button, Row, Col, InputNumber, Switch, Input } from 'antd';
import { connect } from 'react-redux';
import { FormComponentProps } from '@ant-design/compatible/lib/form/Form';
import { withRouter } from 'react-router';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import BackButton from '../back_button/BackButton';
import { stockLocationsRestCrudThunksForSupplier } from '../../thunks/stock_locations_thunks';
import { getProtectedImageUriForSupplier } from '../../utils/FileAccessUtils';

import { partsPerStockLocationsRestCrudThunksForSupplier } from '../../thunks/parts_per_stock_locations_thunks';
import { partsRestCrudThunksForSupplier } from '../../thunks/parts_thunks';
import Ellipsis from 'ant-design-pro/lib/Ellipsis';

require('./StockLocationPartsForm.less');

interface StockLocationPartsFormProps extends FormComponentProps {
	formData: any;
	match: any;
	history: any;
	redirectForwardUrl?: string;
	onSuccess?: any;
	createErrors: any[];
	updateErrors: any[];
	currentUser: any;
	createBulk: any;
	create: any;
	update: any;
	partsPerStockLocations: any;
	fetchPart: any;
	fetchParts: any;
	fetchMultipleParts: any;
	parts: any;
	getStockLocation: any;
}

class StockLocationPartsForm extends React.Component<StockLocationPartsFormProps, any> {
	formRefs: any;

	constructor(props) {
		super(props);
		this.state = {
			previewVisible: false,
			uploadLoading: false,
			previewImage: null,
			formDataInitialized: false,
			updating: false,
		};
		this.formRefs = {
			addPartForm: null,
		};
	}

	saveFormRef = (formName) => (formRef) => {
		this.formRefs[formName] = formRef;
	};

	handleSubmit = (e, submitAction) => {
		const { history, onSuccess, redirectForwardUrl, formData } = this.props;
		e.preventDefault();
		this.props.form.validateFields((err, values) => {
			if (!err) {
				this.setState({ updating: true });
				const partLines = formData.partsAtStockLocation;
				const entities = values.partsStockLocationKeys.map((partsKey) => {
					if (values[`partsStockLocation-${partsKey}-partId`]) {
						const id = values[`partsStockLocation-${partsKey}-id`];
						const partItem = partLines.find((_) => _.id === id) || {};
						return {
							...partItem,
							id,
							partsPerStockLocationUUID:
								values[`partsStockLocation-${partsKey}-partsPerStockLocationUUID`],
							partId: values[`partsStockLocation-${partsKey}-partId`],
							onHandQuantity: parseInt(values[`partsStockLocation-${partsKey}-onHandQuantity`], 10),
							availableQuantity: parseInt(
								values[`partsStockLocation-${partsKey}-availableQuantity`],
								10
							),
							minQuantity: parseInt(values[`partsStockLocation-${partsKey}-minQuantity`], 10),
							maxQuantity: parseInt(values[`partsStockLocation-${partsKey}-maxQuantity`], 10),
							isStocked: values[`partsStockLocation-${partsKey}-isStocked`],
							stockLocationId: values.id,
							supplierFacilityId: values.supplierFacilityId,
							supplierCompanyId: values.supplierCompanyId,
						};
					}
				});

				submitAction(entities)
					.then(() => {
						if (redirectForwardUrl) {
							history.push(redirectForwardUrl);
						}
						if (onSuccess) {
							onSuccess(values.id);
						}
					})
					.finally(() => this.setState({ updating: false }));
			}
		});
	};

	handlePreview = (file) => {
		this.setState({
			previewImage: file.url || file.thumbUrl,
			previewVisible: true,
		});
	};

	handleCancel = () => this.setState({ previewVisible: false });

	handleLocationAutocompleteSelect = (addr, lonLat, parsedAddress) => {
		const { form } = this.props;
		form.setFieldsValue({
			'primaryAddress-streetAddress1': parsedAddress.streetAddress1,
			'primaryAddress-city': parsedAddress.city,
			'primaryAddress-region': parsedAddress.region,
			'primaryAddress-postcode': parsedAddress.postcode,
			'primaryAddress-country': parsedAddress.country,
			longitude: lonLat.lng,
			latitude: lonLat.lat,
		});
	};

	addItem = (itemTypeVarName, uuid) => {
		const { form } = this.props;
		// can use data-binding to get
		const keys = form.getFieldValue(itemTypeVarName) || [];
		const nextKeys = keys.concat(uuid);
		// can use data-binding to set
		// important! notify form to detect changes
		form.setFieldsValue({
			[itemTypeVarName]: nextKeys,
		});
		return uuid + 1;
	};

	removeItem = (itemTypeVarName, k) => {
		const { form } = this.props;

		// can use data-binding to get
		const keys = form.getFieldValue(itemTypeVarName);

		// can use data-binding to set
		form.setFieldsValue({
			[itemTypeVarName]: keys.filter((key) => key !== k),
		});
	};

	previewPartImage = (part) =>
		nullSafeGet('images', part) && part.images.length > 0
			? part.images.map((locImg) => {
					const [imgFileId, imgFileName] = locImg.split('/');
					return getProtectedImageUriForSupplier(imgFileId, imgFileName, 1200, 800);
			  })[0]
			: null;

	render() {
		const { form, createErrors, formData, updateErrors, currentUser, createBulk } = this.props;
		const { formDataInitialized } = this.state;
		const { getFieldDecorator, getFieldValue } = form;
		const submitAction = createBulk;
		const submitText = 'Update parts';

		if (!formDataInitialized) {
			if (formData.partsAtStockLocation) {
				const partLines = formData.partsAtStockLocation;
				formData.partsStockLocationKeys = partLines.map((el, idx) => idx);
				partLines.forEach((lineItem, idx) => {
					formData[`partsStockLocation-${idx}-id`] = lineItem.id;
					formData[`partsStockLocation-${idx}-partId`] = lineItem.partId;
					formData[`partsStockLocation-${idx}-part`] = lineItem.part;
					formData[`partsStockLocation-${idx}-onHandQuantity`] = lineItem.onHandQuantity;
					formData[`partsStockLocation-${idx}-availableQuantity`] = lineItem.availableQuantity;
					formData[`partsStockLocation-${idx}-minQuantity`] = lineItem.minQuantity;
					formData[`partsStockLocation-${idx}-maxQuantity`] = lineItem.maxQuantity;
					formData[`partsStockLocation-${idx}-isStocked`] = lineItem.isStocked;
				});
			}
			this.setState({ formDataInitialized: true });
		}

		getFieldDecorator('supplierFacilityId', {
			initialValue: formData.supplierFacilityId || nullSafeGet('facility.id', currentUser),
		});
		getFieldDecorator('supplierCompanyId', {
			initialValue:
				formData.supplierCompanyId || nullSafeGet('facility.supplierCompanyId', currentUser),
		});

		getFieldDecorator('id', { initialValue: formData.id });

		getFieldDecorator('partsStockLocationKeys', {
			initialValue: formData.partsStockLocationKeys || [],
		});

		const partsStockLocationKeys = getFieldValue('partsStockLocationKeys');

		const partsFormItems = partsStockLocationKeys.map((k, partsIndex) => {
			getFieldDecorator(`partsStockLocation-${k}-id`, {
				initialValue: nullSafeGet(`partsStockLocation-${k}-id`, formData),
			});
			getFieldDecorator(`partsStockLocation-${k}-partsPerStockLocationUUID`, {
				initialValue: nullSafeGet(`partsStockLocation-${k}-partsPerStockLocationUUID`, formData),
			});
			return (
				<Row key={k} align="middle">
					{getFieldDecorator(`partsStockLocation-${k}-partId`, {
						initialValue: nullSafeGet(`partsStockLocation-${k}-partId`, formData),
					})}

					<Col span={8}>
						<Form.Item>
							<div
								className="partStockLocationRowDisplay"
								style={{ justifyContent: 'space-between' }}
							>
								<div className="flex flex-col">
									<div className="partStockLocationRowDisplay__rowTitle">
										<Ellipsis tooltip={true} length={56}>
											{nullSafeGet(`partsStockLocation-${k}-part.name`, formData)}
										</Ellipsis>
									</div>
									{nullSafeGet(`partsStockLocation-${k}-part.partNumber`, formData) && (
										<div className="partStockLocationRowDisplay__rowSubtitle">
											{`Part #${nullSafeGet(`partsStockLocation-${k}-part.partNumber`, formData)}`}
										</div>
									)}
								</div>
							</div>
						</Form.Item>
					</Col>
					<Col span={2} offset={1}>
						<Form.Item style={{ textAlign: 'center' }}>
							{getFieldDecorator(`partsStockLocation-${k}-isStocked`, {
								initialValue: nullSafeGetOrElse(
									`partsStockLocation-${k}-isStocked`,
									formData,
									false
								),
								valuePropName: 'checked',
							})(<Switch />)}
						</Form.Item>
					</Col>
					<Col span={2} offset={1}>
						<Form.Item>
							{getFieldDecorator(`partsStockLocation-${k}-availableQuantity`, {
								initialValue: nullSafeGetOrElse(
									`partsStockLocation-${k}-availableQuantity`,
									formData,
									0
								),
								validateTrigger: ['onBlur'],
								rules: [
									{
										required: true,
										message: 'Please add available quantity.',
									},
								],
							})(<InputNumber disabled style={{ width: '100%' }} />)}
						</Form.Item>
					</Col>
					<Col span={2} offset={1}>
						<Form.Item>
							{getFieldDecorator(`partsStockLocation-${k}-onHandQuantity`, {
								initialValue: nullSafeGetOrElse(
									`partsStockLocation-${k}-onHandQuantity`,
									formData,
									0
								),
								validateTrigger: ['onBlur'],
								rules: [
									{
										required: true,
										message: 'Please add on hand quantity.',
									},
								],
							})(<InputNumber style={{ width: '100%' }} />)}
						</Form.Item>
					</Col>
					<Col span={2} offset={1}>
						<Form.Item>
							{getFieldDecorator(`partsStockLocation-${k}-minQuantity`, {
								initialValue: nullSafeGetOrElse(`partsStockLocation-${k}-minQuantity`, formData, 0),
								validateTrigger: ['onBlur'],
								rules: [
									{
										required: true,
										message: 'Please add minimum quantity.',
									},
								],
							})(<InputNumber style={{ width: '100%' }} />)}
						</Form.Item>
					</Col>
					<Col span={2} offset={1}>
						<Form.Item>
							{getFieldDecorator(`partsStockLocation-${k}-maxQuantity`, {
								initialValue: nullSafeGetOrElse(`partsStockLocation-${k}-maxQuantity`, formData, 0),
								validateTrigger: ['onBlur'],
								rules: [
									{
										required: true,
										message: 'Please add minimum quantity.',
									},
								],
							})(<InputNumber style={{ width: '100%' }} />)}
						</Form.Item>
					</Col>
					<Col span={1} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
						<Form.Item>
							{partsStockLocationKeys.length > 0 ? (
								<MinusCircleOutlined
									translate=""
									className="dynamic-delete-button"
									onClick={() => this.removeItem('partsStockLocationKeys', k)}
								/>
							) : null}
						</Form.Item>
					</Col>
				</Row>
			);
		});

		const partsHeader = (
			<Row className="text-slate-500">
				{/* <Col span={1}>
					<div
						style={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
					></div>
				</Col> */}

				<Col span={8}>
					<div className="flex flex-row justify-start">Part</div>
				</Col>
				<Col span={2} offset={1}>
					<div className="flex flex-row justify-center">Is Stocked</div>
				</Col>
				<Col span={2} offset={1}>
					<div className="flex flex-row justify-center">Available Qty</div>
				</Col>
				<Col span={2} offset={1}>
					<div className="flex flex-row justify-center">On Hand Qty</div>
				</Col>
				<Col span={2} offset={1}>
					<div className="flex flex-row justify-center">Min Qty</div>
				</Col>
				<Col span={2} offset={1}>
					<div className="flex flex-row justify-center">Max Qty</div>
				</Col>
				<Col span={1} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
					<div
						style={{
							padding: 12,
							marginTop: 16,
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
					></div>
				</Col>
			</Row>
		);

		const partsForm = (
			<div style={{ marginBottom: 32 }}>
				{partsStockLocationKeys.length > 0 ? partsHeader : null}
				{partsFormItems}
			</div>
		);

		return (
			<Form
				layout="vertical"
				onSubmit={(e) => this.handleSubmit(e, submitAction)}
				className="supplierForm"
			>
				{createErrors.length > 0 ? (
					<Form.Item>
						<Alert message={createErrors.join(' ')} type="error" />
					</Form.Item>
				) : null}
				{updateErrors.length > 0 ? (
					<Form.Item>
						<Alert message={updateErrors.join(' ')} type="error" />
					</Form.Item>
				) : null}
				{partsForm}
				<Form.Item>
					<Button
						type="primary"
						htmlType="submit"
						loading={this.state.updating}
						className="contactForm__button"
					>
						{submitText}
					</Button>
					<span style={{ marginLeft: '16px' }}>
						<BackButton buttonText="Cancel" />
					</span>
				</Form.Item>
			</Form>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
	formData: ownProps.formData,
	match: ownProps.match,
	redirectForwardUrl: ownProps.redirectForwardUrl,
	onSuccess: ownProps.onSuccess,

	createErrors: state.parts_per_stock_locations.createErrors,
	updateErrors: state.parts_per_stock_locations.updateErrors,
	currentUser: state.session.currentUser,
	partsPerStockLocations: state.parts_per_stock_locations,
	parts: state.parts,
});

const mapDispatchToProps = (dispatch) => ({
	createBulk: (entities) =>
		dispatch(partsPerStockLocationsRestCrudThunksForSupplier.createBulk(entities)),
	update: (entity) => dispatch(partsPerStockLocationsRestCrudThunksForSupplier.update(entity)),
	fetchPart: (id) => dispatch(partsRestCrudThunksForSupplier.readOne(id)),
	fetchParts: (params, targetCollectionName) =>
		dispatch(partsRestCrudThunksForSupplier.read(params, targetCollectionName)),
	fetchMultipleParts: (ids, targetCollectionName) =>
		dispatch(partsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	getStockLocation: (id) => dispatch(stockLocationsRestCrudThunksForSupplier.readOne(id)),
});

export default withRouter<any, any>(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(Form.create<StockLocationPartsFormProps>()(StockLocationPartsForm))
);
